import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PublicationCommonLoader = () => (
  <Row width="100%">
    <Col>
      <Box flexDirection={{ _: 'column', l: 'row' }} px={{ l: 6 }}>
        <Skeleton
          width={{ s: '100%', l: '468px' }}
          height={{ s: '192px', m: '306px', l: '228px' }}
          mb={4}
        />
        <Box
          flexDirection="column"
          pl={{ l: 6 }}
          width={{ s: '100%', l: '40%' }}
        >
          <Skeleton height={32} mb={4} width="100%" />
          <Skeleton height={66} mb={4} width="100%" />
          <Skeleton height={36} width="50%" />
        </Box>
      </Box>
      <Box flexDirection={{ _: 'column' }} mt={3} px={{ l: 6 }}>
        <Skeleton height={14} mb={4} width="20%" />
        <Skeleton height={2} mb={4} width="100%" />
        {Array.from({
          length: 3,
        }).map((_, i) => (
          <Skeleton key={i} height={16} mb={2} width="100%" />
        ))}
        <Skeleton height={16} width="90%" />
      </Box>
    </Col>
  </Row>
);

export default PublicationCommonLoader;
